module.exports = __webpack_public_path__ + "img/mtc-main.47517a74.jpg";